// Error Priority / Sort-Tiers
export const PRIORITY_LOW = 2;
export const PRIORITY_MED = 1;
export const PRIORITY_HIGH = 0;

// Errors
export const ERROR_CART_EMPTY = 'ERROR_CART_EMPTY';
export const ERROR_CART_NEGATIVE_COMP_BALANCE = 'ERROR_CART_NEGATIVE_COMP_BALANCE';
export const ERROR_ITEM_EXPIRED = 'ERROR_ITEM_EXPIRED';
export const ERROR_ITEM_FUNDAMENTAL_RULE_EXPIRED = 'ERROR_ITEM_FUNDAMENTAL_RULE_EXPIRED';
export const ERROR_ITEM_UNAVAILABLE = 'ERROR_ITEM_UNAVAILABLE';
export const ERROR_ITEM_QUANTITY_EXCEEDED = 'ERROR_ITEM_QUANTITY_EXCEEDED';
export const ERROR_ITEM_MAX_QUANTITY_EXCEEDED = 'ERROR_ITEM_MAX_QUANTITY_EXCEEDED';
export const ERROR_FREE_ITEM_MAX_QUANTITY_EXCEEDED = 'ERROR_FREE_ITEM_MAX_QUANTITY_EXCEEDED';
export const ERROR_ITEM_UNIT_ALLOTMENT_EXCEEDED = 'ERROR_ITEM_UNIT_ALLOTMENT_EXCEEDED';
export const ERROR_ITEM_QUANTITY_NONE = 'ERROR_ITEM_QUANTITY_NONE';
export const ERROR_ITEM_PRE_PACK = 'ERROR_ITEM_PRE_PACK';
export const ERROR_ITEM_MIN_RULE = 'ERROR_ITEM_MIN_RULE';
export const ERROR_ITEM_MAX_RULE = 'ERROR_ITEM_MAX_RULE';
export const ERROR_ITEM_PAYMENT_METHOD = 'ERROR_ITEM_PAYMENT_METHOD';
export const ERROR_ITEM_UNMAPPED_ALLOTMENT_PERIOD = 'ERROR_ITEM_UNMAPPED_ALLOTMENT_PERIOD';
export const ERROR_PRODUCT_GROUP_NO_ADDRESS = 'ERROR_PRODUCT_GROUP_NO_ADDRESS';
export const ERROR_FIELD_EMPTY = 'ERROR_FIELD_EMPTY';
export const ERROR_FIELD_INVALID = 'ERROR_FIELD_INVALID';
export const ERROR_PRODUCT_AMOUNT_ORDERABLE_EXCEEDED = 'ERROR_PRODUCT_AMOUNT_ORDERABLE_EXCEEDED';

// Error types
export const ERROR_TYPE_CART = 'TYPE_CART';
export const ERROR_TYPE_CHECKOUT = 'TYPE_CHECKOUT';

// List of all error types
export const ERROR_TYPES_ALL = [ERROR_TYPE_CART, ERROR_TYPE_CHECKOUT];

// Error Data Map
export const ERROR_MAP = {
  ERROR_CART_EMPTY: {
    copyId: 'cart.error.empty.copy',
    priority: PRIORITY_HIGH,
    types: [ERROR_TYPE_CART]
  },
  ERROR_CART_NEGATIVE_COMP_BALANCE: {
    copyId: 'cart.summary.overAllotment',
    priority: PRIORITY_HIGH,
    types: [ERROR_TYPE_CART]
  },
  ERROR_ITEM_EXPIRED: {
    copyId: 'cart.error.itemExpired.copy',
    priority: PRIORITY_HIGH,
    types: [ERROR_TYPE_CART]
  },
  ERROR_ITEM_FUNDAMENTAL_RULE_EXPIRED: {
    copyId: 'cart.error.fundamentalRuleExpired.copy',
    priority: PRIORITY_HIGH,
    types: [ERROR_TYPE_CART]
  },
  ERROR_ITEM_UNAVAILABLE: {
    copyId: 'cart.error.itemUnavailable.copy',
    priority: PRIORITY_HIGH,
    types: [ERROR_TYPE_CART]
  },
  ERROR_ITEM_PAYMENT_METHOD: {
    copyId: 'cart.error.itemPaymentMethod.copy',
    priority: PRIORITY_LOW,
    types: [ERROR_TYPE_CART]
  },
  ERROR_ITEM_UNMAPPED_ALLOTMENT_PERIOD: {
    copyId: 'cart.summary.overAllotment',
    priority: PRIORITY_HIGH,
    types: [ERROR_TYPE_CART]
  },
  ERROR_ITEM_QUANTITY_EXCEEDED: {
    copyId: 'cart.error.itemQuantityExceeded.copy',
    priority: PRIORITY_LOW,
    types: [ERROR_TYPE_CART]
  },
  ERROR_ITEM_MAX_QUANTITY_EXCEEDED: {
    copyId: 'cart.error.itemMaxQuantityExceeded.copy',
    priority: PRIORITY_LOW,
    types: [ERROR_TYPE_CART]
  },
  ERROR_FREE_ITEM_MAX_QUANTITY_EXCEEDED: {
    copyId: 'cart.error.itemMaxQuantityExceeded.copy.freeAvailability',
    priority: PRIORITY_LOW,
    types: [ERROR_TYPE_CART]
  },
  ERROR_ITEM_UNIT_ALLOTMENT_EXCEEDED: {
    copyId: 'cart.error.itemUnitAllotmentExceeded.copy',
    priority: PRIORITY_LOW,
    types: [ERROR_TYPE_CART]
  },
  ERROR_ITEM_QUANTITY_NONE: {
    copyId: 'cart.error.itemQuantityEmpty.copy',
    priority: PRIORITY_LOW,
    types: [ERROR_TYPE_CART]
  },
  ERROR_ITEM_PRE_PACK: {
    copyId: 'cart.error.ruleset.prepack.copy', // NOTE - Requires {count} value
    priority: PRIORITY_LOW,
    types: [ERROR_TYPE_CART]
  },
  ERROR_ITEM_MIN_RULE: {
    copyId: 'cart.error.ruleset.min.copy', // NOTE - Requires {amount} value
    priority: PRIORITY_LOW,
    types: [ERROR_TYPE_CART]
  },
  ERROR_ITEM_MAX_RULE: {
    copyId: 'cart.error.ruleset.max.copy', // NOTE - Requires {amount} value
    priority: PRIORITY_LOW,
    types: [ERROR_TYPE_CART]
  },
  ERROR_PRODUCT_AMOUNT_ORDERABLE_EXCEEDED: {
    copyId: 'cart.product.error.maxQuantityExceeded',
    priority: PRIORITY_LOW,
    types: [ERROR_TYPE_CART]
  },
  ERROR_PRODUCT_GROUP_NO_ADDRESS: {
    copyId: 'checkout.error.address',
    priority: PRIORITY_LOW,
    types: [ERROR_TYPE_CHECKOUT]
  },
  ERROR_FIELD_EMPTY: {
    copyId: 'checkout.error.empty', // NOTE - Requires {name} value
    priority: PRIORITY_LOW,
    types: [ERROR_TYPE_CHECKOUT]
  },
  ERROR_FIELD_INVALID: {
    copyId: 'checkout.error.invalid', // NOTE - Requires {name} and {error} values
    priority: PRIORITY_LOW,
    types: [ERROR_TYPE_CHECKOUT]
  }
};

// Shipping detail defaults
export const ERROR_DATA_PHONENUM = { field: 'phoneNumber', name: 'checkout.phonenumber.label' };
export const ERROR_DATA_PHONENUM_EXT = { field: 'phoneNumberExt', name: 'checkout.extension.label' };
export const ERROR_DATA_SHIPPING_METHOD = { field: 'shippingMethod', name: 'checkout.shipping.method.label' };
export const ERROR_DATA_NOTES_TO_NIKE = { field: 'notesToNike', name: 'checkout.notes.to.nike.label' };
export const ERROR_DATA_PURCHASE_ORDER_NUM = {
  field: 'purchaseOrderNumber',
  name: 'checkout.enter.purchase.order.label'
};

export const ERROR_SHIPPING_DETAIL_DATA = [
  ERROR_DATA_PHONENUM,
  ERROR_DATA_PHONENUM_EXT,
  ERROR_DATA_SHIPPING_METHOD,
  ERROR_DATA_NOTES_TO_NIKE,
  ERROR_DATA_PURCHASE_ORDER_NUM
];

export const hiddenErrors = [];

export const errorIsHidden = error => hiddenErrors.includes(error.type);

export const errorIsVisible = error => !errorIsHidden(error);

// Returns whether or not the supplied {error}'s type is found in supplied {types} list
export const errorIsOfType = (error, types) => ERROR_MAP[error.type].types.some(type => types.includes(type));

// Returns whether or not the provided error is a stand-alone error (priority-level medium, or higher)
export const errorIsStandAlone = error => {
  switch (ERROR_MAP[error.type].priority) {
    case PRIORITY_MED:
    case PRIORITY_HIGH:
      return true;

    default:
      return false;
  }
};
